/**
 * Utilidades de validación para IDs y manejo de errores
 */

/**
 * Valida si un ID obtenido de localStorage es válido
 * @param {string|null} id - ID obtenido de localStorage
 * @returns {boolean} - true si el ID es válido
 */
export const isValidStorageId = (id) => {
  return id && id !== 'null' && id !== 'undefined' && id.trim() !== '';
};

/**
 * Maneja errores de API, filtrando errores de ID inválido
 * @param {Error} error - Error capturado
 * @param {string} entityType - Tipo de entidad (Employee, Company, etc.)
 */
export const handleApiError = (error, entityType) => {
  if (error.message !== `${entityType} ID is required`) {
    console.error(error);
  }
};

/**
 * Obtiene el ID del usuario desde localStorage de forma segura
 * @returns {string|null} - ID del usuario o null si no existe
 */
export const getUserId = () => {
  return localStorage.getItem("id");
};

/**
 * Obtiene el rol del usuario desde localStorage de forma segura
 * @returns {string|null} - Rol del usuario o null si no existe
 */
export const getUserRole = () => {
  return localStorage.getItem("rol");
};

/**
 * Verifica si el usuario es una empresa
 * @param {string|number} rol - Rol del usuario
 * @returns {boolean} - true si es empresa (rol 1)
 */
export const isCompany = (rol) => {
  return rol === '1' || rol === 1;
};

/**
 * Crea un manejador de cleanup para useEffect
 * @returns {{isMounted: {current: boolean}, cleanup: Function}}
 */
export const createMountedRef = () => {
  const isMountedRef = { current: true };
  const cleanup = () => {
    isMountedRef.current = false;
  };
  return { isMountedRef, cleanup };
};
